import React from 'react';

import {Select} from 'Components/Form';
import {Loading} from 'Components/Partials';

import AdminUsersApi from 'Services/Api/Admin/Users';
import AdminGroupsApi from 'Services/Api/Admin/Groups';

import {Toast, User} from 'Services';

export default class AdminGroupSelect extends React.Component {
    /**
     * @var state
     */
    state = {
        working: false
    }

    /**
     * @method handleGroupUpdate
     * @param {string|array} group_ids
     */
    handleGroupUpdate = async (group_ids) => {
        this.setState({
            working: true
        });

        const response = await AdminUsersApi.patch(User.id, {
            ...User.data,
            group_ids
        });

        if (!response.success) {
            Toast.error();
        } else {
            window.location.reload();
        }
    }

    /**
     * @method render
     * @returns {JSX.Element}
     */
    render = () => {
        const {working} = this.state;

        if (working) {
            return <Loading size="1x" />;
        }

        let groups_ids = User.data.groups.map((group) => group.id);

        groups_ids = window.base.features.allow_multiple_groups_per_user ? 
            groups_ids : 
            groups_ids[0]

        return (
            <Select
                containerClassName="w-48 text-black"
                value={groups_ids}
                onChange={(v) => this.handleGroupUpdate(v)}
                isAsync
                searchCallback={(data) => AdminGroupsApi.get(null, {
                    ...data,
                    hasNoTeam: true
                })}
                searchLabelKey="name"
                allowNull={!window.base.features.allow_multiple_groups_per_user}
                isMulti={window.base.features.allow_multiple_groups_per_user}
                placeholder="Group..."
            />
        );
    }
}